<template>
  <div>
    <px-gestao-entrega-header @change="onChangeFilter"/>
    <px-gestao-entrega-lista-produtos :produtos="produtos"
                                      :options-list="optionsList"
                                      :loading="loading"
                                      v-model="localValue"
                                      :on-change-options="onChangeOptions"
                                      @change="refresh"/>
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import { mapGetters } from 'vuex';
import GestaoEntregaListaProdutos from '@/modules/entregas/GestaoEntregaListaProdutos.vue';
import GestaoEntregaHeader from '@/modules/entregas/GestaoEntregaHeader.vue';
import ProdutosService from '@/modules/entregas/produtos-service';

export default {
  mixins: [paginationMixin],
  props: {
    value: Array,
  },
  data() {
    return {
      loading: false,
      filters: {},
      produtos: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 15,
        offset: 0,
        filter: '',
        sort: 'dataPrevisaoEntrega',
        sortDesc: true,
      },
      optionsList: {},
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    ...mapGetters('gestaoEntrega', ['stringFilter']),
  },
  methods: {
    refresh() {
      this.getProdutos();
    },
    onChangeFilter(filters) {
      this.filters = filters;
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getProdutos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getProdutos();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getProdutos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      ProdutosService.getComprasProdutos({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then(({ data }) => {
          this.produtos = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.listOptions.filter = this.stringFilter;
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxGestaoEntregaListaProdutos: GestaoEntregaListaProdutos,
    pxGestaoEntregaHeader: GestaoEntregaHeader,
  },
};
</script>
